import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

export type Section = 'Legal Notice' | 'Privacy Policy' | 'Cookie Policy';

@Component({
  standalone: false,
  selector: 'app-legal-text-modal',
  templateUrl: './legal-text.component.html',
  styleUrls: ['./legal-text.component.scss'],
})
export class LegalTextModalComponent implements OnInit, OnDestroy {
  bsModalRef = inject(BsModalRef);
  currentSection: Section = 'Legal Notice';
  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initComponent(): void {}

  close() {
    this.bsModalRef.hide();
  }
}
